module.exports = __webpack_public_path__ + "img/rust.9973f09c.webp";